import React, { useEffect } from "react";

const faqs = [
  {
    question: "Does Simple Step Counter work on iPhone and Android?",
    answer: "Yes. Simple Step Counter is available for iPhone and Android.",
  },
  {
    question: "Is Simple Step Counter free?",
    answer:
      "Yes. The base version is free to use. Optional in-app purchases may be available if you want to support development or unlock extra customization.",
  },
  {
    question: "Does Simple Step Counter show ads?",
    answer:
      "No. Simple Step Counter is designed to be a clean, distraction-free step counter without ads.",
  },
  {
    question: "Do I need an account?",
    answer:
      "No. You can use Simple Step Counter without creating an account or signing in.",
  },
  {
    question: "Is my step data private?",
    answer:
      "Simple Step Counter is built with privacy in mind. Step data is used to show your activity, goals, history, and estimates, and the app avoids unnecessary data collection.",
  },
  {
    question: "Does Simple Step Counter sell my data?",
    answer:
      "No. Simple Step Counter does not sell your step data.",
  },
  {
    question: "Is my activity uploaded to a server?",
    answer:
      "No. Step data is primarily handled on your device. Optional diagnostics or analytics, if enabled, do not include your step history.",
  },
  {
    question: "Does Simple Step Counter use Apple Health or Health Connect?",
    answer:
      "On iPhone, step data can come from Apple Health. On Android, step data can come from your device sensors or Health Connect, depending on your setup and permissions.",
  },
  {
    question: "How accurate is Simple Step Counter?",
    answer:
      "Step counting depends on your device sensors, permissions, and how your phone is carried. Simple Step Counter aims to give a reliable everyday estimate.",
  },
  {
    question: "Why are steps sometimes delayed?",
    answer:
      "Some devices update step data in batches to save battery. Your count may refresh after a short delay.",
  },
  {
    question: "Will it drain my battery?",
    answer:
      "Simple Step Counter is designed to be battery-friendly and focused on everyday step tracking without unnecessary background activity.",
  },
  {
    question: "Can I customize the widget?",
    answer:
      "Yes. Simple Step Counter includes widget customization options so you can adjust the widget to your preferences.",
  },
];

const Faq = () => {
  useEffect(() => {
    const scriptId = "faq-structured-data";
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    });

    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className="page-container">
      <div className="page-content faq-content">
        <h1 className="page-title">Frequently Asked Questions</h1>
        <section className="faq-intro">
          <p>
            Answers to common questions about Simple Step Counter, a minimalist step counter for
            iPhone and Android.
          </p>
        </section>
        <section className="faq-list" aria-label="Frequently asked questions">
          {faqs.map((faq) => (
            <article className="faq-item" key={faq.question}>
              <h2>{faq.question}</h2>
              <p>{faq.answer}</p>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
};

export default Faq;
